import React, { useEffect, useState, useRef } from 'react';
import styles from './Recommendations.module.scss';
import { useSharedCart } from '../../entrypoints/theme';

export default function Recommendations( fullSize = false, cartSize = false ) {
  const [products, setProducts] = useState([]);
  const sliderRef = useRef(null);
  const { cartState } = useSharedCart();
  const recommendationsCollection = cartState.recommendations_collection;

  useEffect(() => {
    fetch(`/collections/${recommendationsCollection}/products.json`)
      .then(response => response.json())
      .then(data => {
        setProducts(data.products || []);
      })
      .catch(error => {
        console.error("Error fetching recommendationsCollection:", error);
      });
  }, [cartState]);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  return (
    <div className={styles.ymalContainer + ' ' + (fullSize ? styles.fullSizeContainer : '') + ' ' + (cartSize ? styles.cartSizeContainer : '')}>
      <div className={styles.ymalHeader}>
        <h2 className={styles.ymalTitle}>You may also like</h2>
        <div className={styles.arrowButtons}>
          <button onClick={scrollLeft} className={`${styles.arrow} ${styles.arrowLeft}`}>
            &lt;
          </button>
          <button onClick={scrollRight} className={`${styles.arrow} ${styles.arrowRight}`}>
            &gt;
          </button>
        </div>
      </div>
      <div className={styles.sliderWrapper}>
        <div className={styles.sliderContainer} ref={sliderRef}>
          {products.map((product) => {
            // Calculate discount percentage
            const price = parseFloat(product.variants[0].price);
            const compareAtPrice = parseFloat(product.variants[0].compare_at_price);
            let discount = 0;
            if (compareAtPrice && compareAtPrice > price) {
              discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
            }

            return (
              !product.tags.includes("BOLD_HIDDEN_PRODUCT") && !product.tags.includes("OPTIONS_HIDDEN_PRODUCT") && product.variants[0].available ? (
                <a href={`/products/${product.handle}`} key={product.id} className={styles.productLink}>
                  <div className={styles.productCard}>
                    <div className={styles.productImageContainer}>
                      <img src={product.images[0].src} alt={product.title} className={styles.productImage} loading="lazy" />
                      {discount > 0 && (
                        <span className={styles.discountBadge}>{discount}% OFF</span>
                      )}
                    </div>
                    <h3 className={styles.productName}>{product.title}</h3>
                    <div className={styles.priceContainer}>
                      <span className={styles.currentPrice}>${price.toFixed(2)}</span>
                      {compareAtPrice && (
                        <span className={styles.originalPrice}>${compareAtPrice.toFixed(2)}</span>
                      )}
                    </div>
                    {/* <StarRating rating={product.rating} reviews={product.reviews} /> */}
                  </div>
                </a>
              ) : null
            );
          })}
        </div>
      </div>
    </div>
  );
}
